import { render, staticRenderFns } from "./NewPasswordForm.vue?vue&type=template&id=6befbdf2&scoped=true&"
import script from "./NewPasswordForm.vue?vue&type=script&lang=js&"
export * from "./NewPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6befbdf2",
  null
  
)

export default component.exports